import IntranetLayout from "@/components/IntranetLayout";
import AuditRoom from "@/components/AuditRoom";

const EmployeeAuditRoom = () => (
  <IntranetLayout>
    <div className="mb-6">
      <h1 className="text-2xl font-display font-semibold">Audit Room</h1>
      <p className="text-sm text-muted-foreground mt-1">
        Live channel with the flag-state auditor. Answer questions, upload evidence and controlled
        documents — everything is mirrored to the auditor's portal in real time.
      </p>
    </div>
    <AuditRoom theme="light" />
  </IntranetLayout>
);

export default EmployeeAuditRoom;
